import {Component, inject, Input, OnChanges} from '@angular/core';
import {SearchHandlerService} from '../../search-handler.service';
import {FocusServiceImplementation, SearchFocusService} from '../../search-focus.service';
import {SearchViewMenu} from '../../../core/definitions/search-objects';
import {SearchFilterService} from '../../search-filter.service';
import {SearchContainer} from '../../../core/definitions/search-container';
import {PrimusStateMapperService} from '../../../core/primus-state-mapper.service';
import {SearchViewCategoryMenuService} from "../../search-view-category-menu.service";

@Component({
    selector: 'app-search-filter-menu-item',
    templateUrl: './search-filter-menu-item.component.html',
    styleUrls: ['./search-filter-menu-item.component.scss'],
    standalone: false
})
export class SearchFilterMenuItemComponent implements OnChanges {
  // Injections
  public primusStateMapper: PrimusStateMapperService = inject(PrimusStateMapperService);
  private readonly categoryMenuService: SearchViewCategoryMenuService = inject(SearchViewCategoryMenuService);
  private readonly searchFilterService: SearchFilterService = inject(SearchFilterService);
  private readonly searchFocusService: SearchFocusService = inject(SearchFocusService);
  private readonly searchHandler: SearchHandlerService = inject(SearchHandlerService);

  @Input() menu: SearchViewMenu;
  @Input() sideMenu;
  @Input() subMenu;
  @Input() searchContainer: SearchContainer;

  private fsi: FocusServiceImplementation;

  ngOnChanges() {
    if (this.menu) {
      if (this.menu.menus && this.menu.order === 0) {
        this.setOpenItem(this.menu);
      }
    }
  }

  isDisabled() {
    return this.searchContainer.queryContainer.selectedQueryMenu.query_type === 'advanced' && (this.menu.path === 'home/locations' || this.menu.path === 'home/places' || this.menu.count <= 1);
  }

  openFilterItem(menu) {
    this.setOpenItem(menu);
  }

  async checkMenuFilter($event) {
    await this.searchFilterService.checkMenuFilter(this.menu, this.searchContainer);
  }

  async goToMenuPath(): Promise<void> {
    this.fsi = this.searchFocusService.createFSI(this.searchContainer);
    if (this.searchContainer.focus.curFocus && this.searchContainer.focus.curFocus.focus.stored) {
      const exists = this.searchFocusService.checkPathParamsExists(this.menu.path, this.searchContainer);
      if (!exists) {
        await this.fsi.createOrUpdateFocus(this.searchContainer.focus.curFocus);
      }
    }
    this.searchContainer.objectCount = 0;
    this.searchContainer.path = this.menu.path;
    await this.searchHandler.goPathView(this.searchContainer.path, this.searchContainer);
  }

  private setOpenItem(menu: SearchViewMenu) {
    this.categoryMenuService.getCategoryMenus(this.searchContainer.currentPathView.search_view.menus).then(categoryMenus => {
      for (const mainMenu of categoryMenus) {
        if (menu.facet_values === mainMenu.facet_values) {
          menu.openItem = !menu.openItem;
        } else {
          mainMenu.openItem = false;
        }
      }
    })
  }

}
